export default {
  title: 'HOTEL TIMEOUT SETTINGS' ,
  items: {
    HotelResponseTime: {
      label: 'Hotel Response Time',
      type: 'integer',
      unit: 'seconds'
    },
    HotelCustomerResponseTime: {
      label: 'Customer Response Time',
      type: 'integer',
      unit: 'seconds'
    },
    HotelServerConnectionTimeout: {
      label: 'Server Connection Timeout',
      type: 'integer',
      unit: 'seconds'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/hotel-timeout-settings.js